import { CanalChaveApiCodec } from "./CanalChaveApiCodec";

export type CanalChaveApiTelegram = {
    tipo: "telegram";
    token: string;
    username?: string; // @nome_bot, sem o "@" — usado para montar o link https://t.me/<username>
};

export class CanalChaveApiCodecTelegram implements CanalChaveApiCodec<CanalChaveApiTelegram> {
    encode(value: CanalChaveApiTelegram): string {
        return JSON.stringify(value);
    }
    decode(value: string): CanalChaveApiTelegram {
        // Suporte a formato antigo (apenas o token) e novo (JSON)
        if (value.startsWith("{")) {
            return JSON.parse(value) as CanalChaveApiTelegram;
        }
        return { tipo: "telegram", token: value };
    }
}
